import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrganizationSectionCardProps } from '@modules/organization/models/organization.model.ts';

const OrganizationSectionCard: React.FC<OrganizationSectionCardProps> = ({
  title,
  description,
  className = '',
  children
}) => {
  const { t } = useTranslation();

  return (
    <section
      className={`rounded-2xl border border-(--gray-7) bg-(--white) px-8 pt-7 pb-6 shadow-[0_1px_3px_rgba(20,20,40,0.04)] max-lg-xl:px-6 max-lg-xl:pt-5 ${className}`}
    >
      <Typography variant="subtitle4">{t(title)}</Typography>
      <Typography variant="body2" className="mt-1! font-medium! opacity-70!">
        {t(description)}
      </Typography>

      <div className="mt-7 max-lg-xl:mt-5">{children}</div>
    </section>
  );
};

export default OrganizationSectionCard;
